"use strict";
import { jsx } from "react/jsx-runtime";
import $ from "jquery";
import ResetPasswordPage from "./accounts_payable/reset_password/reset_password_page";
import Hotkeys from "./util/hotkeys";
import history from "./accounts_payable/app_history";
import AppRouter from "./accounts_payable/routes";
import { Provider } from "react-redux";
import configureStore from "./accounts_payable/redux/configure_store";
import React from "react";
import ErrorBoundary from "./components/error_boundary";
import { createRoot } from "./util/create_root";
global.__DEV__ = process.env.NODE_ENV === "development";
if (__DEV__) {
  window.React = React;
}
$.ajaxSetup({
  beforeSend: function(jqXHR, settings) {
    jqXHR.url = settings.url;
    jqXHR.data = settings.data;
  }
});
window.$hubtranHistory = history;
const store = configureStore();
function NewRoot() {
  if (window.location.pathname == "/users/password/edit") {
    return /* @__PURE__ */ jsx(ResetPasswordPage, {});
  } else {
    return /* @__PURE__ */ jsx(Provider, { store, "data-component": "NewRoot", children: /* @__PURE__ */ jsx(AppRouter, {}) });
  }
}
const AP = {
  bootstrap: function() {
    Hotkeys.listenForKeys(
      {
        zoomIn: ["numplus", "alt+="],
        zoomOut: ["numminus", "alt+-"],
        rotateLeft: ["left"],
        rotateRight: ["right"],
        nextPage: ["alt+p", "pagedown"],
        prevPage: ["alt+shift+p", "pageup"],
        nextGroup: "alt+g",
        prevGroup: "alt+shift+g",
        togglePOD: ["alt+d", "numpad0", "alt+shift+d"],
        markIllegible: ["alt+t"],
        toggleHidden: ["alt+h"],
        changeDoctype: ["numstar", "alt+e"],
        hotkeyMenu: ["ctrl+/"]
      },
      this
    );
    if (window.location.pathname == "/passwords/expired_token" || window.location.pathname.startsWith("/driver_app/links/"))
      return;
    createRoot(document.getElementById("react-container")).render(
      /* @__PURE__ */ jsx(ErrorBoundary, { name: "accounts-payable", children: /* @__PURE__ */ jsx(NewRoot, {}) })
    );
  }
};
window.AccountsPayable = AP;
$(document).ready(function() {
  AP.bootstrap();
});
export default AP;
